import { Extension } from "@tiptap/core";

import { ActionButton } from "../../../components";

export const ColumnActionButton =
	Extension.create(
	{
		name: "columnActionButton",
		addOptions() {
			return {
				...this.parent?.(),
				button: ({ editor, t }) => ({
					component: ActionButton,
					componentProps: {
						action: () => {
							editor.chain().focus().insertColumns({ cols: 2 }).run();
						},
						icon: "Columns",
						tooltip: t("editor.columns.tooltip")
					}
				})
			};
		}
	});
